import axios from 'axios';
import { stagingServerUrl } from '../server/constants';
import { errorLog } from '../utils/commonUtils';

const _valEmail: any = async (email: string) => {
  const rEmail = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,10}$/i;
  if (!rEmail.test(email)) {
    return;
  }
  try {
    const res = await axios.post(`${stagingServerUrl}/account/verify/unique/email`, {email});
    return res && res.data ? res.data.data : '';
  } catch (e) {
    errorLog(e);
    return;
  }
};

export default _valEmail;
